import DescriptionText from 'elements/DescriptionText';
import ds, { media } from 'designsystem';

const PersonDescription = DescriptionText.extend`
  font-size: ${ds.fontSize('s')};
  line-height: calc(${ds.get('type.lineHeight.s')} / 1.1);
  font-weight: ${ds.get('type.fontWeight.regular')};
  margin-top: calc(${ds.get('metrics.xs')} / 3);
  margin-bottom: ${ds.get('metrics.s')};
  
  ${media.desktop`
    font-size: ${ds.fontSize('base')};
    line-height: ${ds.get('type.lineHeight.s')};
  `}
`;

export default PersonDescription;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/PersonDescription.jsx